import { IconButton } from '@chakra-ui/button';
import { HamburgerIcon } from '@chakra-ui/icons';
import { Box, BoxProps, HStack } from '@chakra-ui/layout';
import { useMediaQuery } from '@chakra-ui/media-query';
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu';

const ResponsiveMenu = ({ children, ...props }: BoxProps): JSX.Element => {
    const [showAsMenu] = useMediaQuery('(max-width: 720px)');

    return (
        <Box {...props}>
            {showAsMenu && Array.isArray(children) ? (
                <Menu>
                    <MenuButton
                        as={IconButton}
                        aria-label="Options"
                        icon={<HamburgerIcon fontSize="1.6em" />}
                        variant="outline"
                    />
                    <MenuList zIndex="999">
                        {children.map((child, index) =>
                            child ? <MenuItem key={`menu-${index}`}>{child}</MenuItem> : null
                        )}
                    </MenuList>
                </Menu>
            ) : (
                <HStack>{children}</HStack>
            )}
        </Box>
    );
};

export default ResponsiveMenu;
